import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { roundToDecimal } from 'utils';

import RateSvg from 'components/common/rating-small.svg';

export const RatingSummary = ({ rating }) => {
  const { t } = useTranslation();

  if (!rating) {
    return null;
  }
  const roundedRating = roundToDecimal(rating);
  return (
    <RateBlock
      className="rating-summary__rate-block"
      aria-label={t('overallReviewRating', {
        rating: roundedRating,
        defaultValue: 'Overall review rating {{rating}} of 5',
      })}
    >
      <YellowStar aria-hidden />
      {roundedRating}
    </RateBlock>
  );
};

RatingSummary.propTypes = {
  rating: PropTypes.number,
};

RatingSummary.defaultProps = {
  rating: 0,
};

const RateBlock = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const YellowStar = styled(RateSvg)`
  margin-right: 7px;
`;
